import * as React from 'react';
import classNames from 'classnames';
import * as Classes from '../common/classes';
import { BaseProps } from '../common/props';

export const HelperType = {
  WARNING: 'warning' as 'warning',
  ERROR: 'error' as 'error',
};
export type HelperType = typeof HelperType[keyof typeof HelperType];

export interface IHelperText extends BaseProps {
  type: HelperType;
}

export class HelperText extends React.PureComponent<IHelperText> {
  render() {
    const { className, type, children, dataTest, ...other } = this.props;

    const cls = classNames(Classes.RF_HELPER_TEXT, className, {
      [Classes.RF_WARNING]: type === HelperType.WARNING,
      [Classes.RF_ERROR]: type === HelperType.ERROR,
    });

    return (
      <div data-test={dataTest} className={cls} {...other}>
        {children}
      </div>
    );
  }
}
